import Paper from '@mui/material/Paper';
import type { ReactNode, RefObject } from 'react';

type Props = {
  children: ReactNode;
  componentRef?: RefObject<HTMLDivElement>;
  alignContent?: 'top' | 'center' | 'bottom';
  fullWidth?: boolean;
  fullHeight?: boolean;
};

export function ContentWrapper({
  children,
  componentRef,
  alignContent = 'top',
  fullWidth = false,
  fullHeight = false,
}: Props) {
  return (
    <Paper
      elevation={0}
      ref={componentRef}
      sx={{
        borderRadius: '0.5rem',
        padding: { xs: '0.75rem', sm: '1rem' },
        alignContent,
        width: fullWidth ? '100%' : 'fit-content',
        height: fullHeight ? '100%' : 'fit-content',
      }}
    >
      {children}
    </Paper>
  );
}
